import { combineReducers } from 'redux';
import carriersReducer from './carriers.reducer';
import givenConsentsReducer from './givenConsents.reducer';
import paginationReducer from './pagination.reducer';

export default combineReducers({
  carriers: carriersReducer,
  givenConsents: givenConsentsReducer,
  pagination: paginationReducer,
});
